<template>
  <div class="nav-container">
    <SupportPalestine
      v-if="!isLoggedIn"
      :institute_name="institute_name"
    ></SupportPalestine>
    <nav
      :class="navbarClass"
      class="d-flex align-items-center justify-content-between"
      :style="{ top: isLoggedIn ? '0px' : '4rem' }"
    >
      <router-link
        :to="{ name: 'FancyHome' }"
        class="logo d-flex align-items-center text-decoration-none"
      >
        <!-- Add @click.stop to the <v-app-bar-nav-icon> to prevent the click event from triggering navigation -->
        <div class="dashboard-drawer-icon">
          <v-icon
            v-show="isDashboardRoute"
            @click.prevent="toggleDashboardDrawer"
            :color="isScrolled ? 'black' : 'white'"
            size="22"
            class="mr-1"
            >mdi-menu</v-icon
          >
        </div>
        <img :src="instituteLogo" alt="logo" />
      </router-link>

      <ul class="menu-list">
        <li
          :class="navItemClass"
          v-for="headerList in headerData.headerLinks"
          :key="headerList.id"
        >
          <router-link
            v-if="
              headerList.componentName &&
              !hideForKuttab(headerList.hideForAlkuttab)
            "
            :to="{ name: headerList.componentName }"
            :class="{ disabled: headerList.isDisabled }"
          >
            {{ getSafeTranslation("header." + headerList.name) }}
          </router-link>
          <a :href="headerList.link" v-else-if="headerList.link">
            {{ getSafeTranslation("header." + headerList.name) }}
          </a>
          <span
            v-else-if="headerList.subMenu"
            :class="subMenuNavItemClass"
            class=""
          >
            <span
              :style="{ color: isScrolled ? 'rgb(56, 56, 56)' : '#fff' }"
              class="submenu-nav-item-text"
            >
              {{ getSafeTranslation("header." + headerList.name) }}
            </span>
            <v-icon
              :color="isScrolled ? 'rgb(56, 56, 56)' : '#fff'"
              class="submenu-nav-item-icon"
              >mdi-chevron-down
            </v-icon>
          </span>
          <template v-if="headerList.subMenu && headerList.subMenu.length">
            <ul class="sub-menu-list">
              <li
                v-for="subLink in headerList.subMenu"
                :key="subLink.id"
                @mouseover="currentMenuId = subLink.id"
                @mouseleave="currentMenuId = null"
                style="position: relative"
              >
                <template v-if="subLink.hasCategories">
                  <div class="sub-link-with-category">
                    <span>{{ subLink.name }}</span>
                    <v-icon
                      v-if="subLink.categories && subLink.categories.length > 0"
                      >mdi-chevron-right</v-icon
                    >
                    <ul
                      class="categories-list"
                      v-if="currentMenuId === subLink.id"
                    >
                      <li
                        v-for="category in subLink.categories"
                        :key="category.id"
                      >
                        <router-link
                          :to="{
                            name: category.componentName,
                            params: { id: category.id },
                          }"
                        >
                          {{ category.name }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <router-link
                    :to="{
                      name: subLink.componentName,
                      params: { id: subLink.id },
                    }"
                  >
                    <!-- {{ $t("header." + subLink.name) }} -->
                    {{ subLink.name }}
                  </router-link>
                </template>
              </li>
            </ul>
          </template>
        </li>
      </ul>
      <div :class="scrollActions" class="actions">
        <CurrencyList />
        <SwitchLang :isScrolled="isScrolled" class="lang-btn" />
        <template v-if="state.isAuthenticated">
          <NotificationsPanel class="mr-2" :isScrolled="isScrolled" />
          <div class="user-menu">
            <ProfileMenu />
          </div>
          <!-- <button class="user-menu position-relative">
            <v-icon :color="isScrolled ? 'rgb(56, 56, 56)' : '#fff'"
              >mdi-account
            </v-icon>
            <span class="full-name"> {{ fullName }} </span>
            <v-icon :color="isScrolled ? 'rgb(56, 56, 56)' : '#fff'"
              >mdi-chevron-down
            </v-icon>
            <ul class="user-sub-menu">
              <li
                v-for="menuLink in headerData.header_menu[
                  state.StateUser.user.user_type.includes('student')
                    ? 'student'
                    : state.StateUser.user.user_type
                ]"
                :key="menuLink.id"
              >
                <router-link :to="{ name: menuLink.componentName }">{{
                  getSafeTranslation("header." + menuLink.name)
                }}</router-link>
              </li>
              <li>
                <Logout class="logout-btn" />
              </li>
            </ul>
          </button> -->
        </template>
        <template v-else>
          <v-btn id="login-btn" class="login-btn" v-on:click="openLoginModal">
            {{ getSafeTranslation("header.login") }}
          </v-btn>
          <v-btn
            id="register-btn"
            class="register-btn"
            v-on:click="openRegisterModal"
          >
            {{ getSafeTranslation("header.signUpForFree") }}
          </v-btn>
        </template>
      </div>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="drawer"
        :class="drawing"
        :color="isScrolled ? 'rgb(102,102,102)' : 'white'"
      ></v-app-bar-nav-icon>
      <!-- Drawer for small screen -->
      <v-navigation-drawer
        v-model="drawer"
        app
        fixed
        temporary
        overlay-color="#000"
        overlay-opacity="0.7"
        disable-resize-watcher
      >
        <v-list nav dense>
          <v-list-item-group>
            <template v-if="!state.isAuthenticated">
              <v-list-item class="drawer-login-btn" v-on:click="openLoginModal">
                <span>
                  {{ $t("header.login") }} / {{ $t("header.signUpForFree") }}
                </span>
              </v-list-item>
              <hr />
            </template>
            <template v-else>
              <div>
                <v-expansion-panels accordion flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      {{ fullName }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content
                      v-for="menu_list in headerData.header_menu[
                        state.StateUser.user.user_type
                      ]"
                      :key="menu_list.id"
                    >
                      <div class="sm-categories-list">
                        <router-link :to="{ name: menu_list.componentName }">
                          {{ $t("header." + menu_list.name) }}
                        </router-link>
                      </div>
                    </v-expansion-panel-content>
                    <v-expansion-panel-content>
                      <div class="sm-categories-list">
                        <Logout class="logout-btn" />
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- <hr /> -->
              </div>
            </template>
            <div
              v-for="headerList in headerData.headerLinks"
              :key="headerList.id"
            >
              <v-expansion-panels
                v-if="headerList.subMenu && headerList.subMenu.length"
                accordion
                flat
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    {{ $t("header." + headerList.name) }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-for="subMenuLink in headerList.subMenu"
                    :key="subMenuLink.id"
                  >
                    <div v-if="subMenuLink.hasCategories">
                      <!-- opened categories -->

                      <v-expansion-panels accordion flat>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            {{ subMenuLink.name }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content style="padding: 0">
                            <div class="sm-categories-list">
                              <router-link
                                v-for="category in subMenuLink.categories"
                                :key="category.id"
                                :to="{
                                  name: category.componentName,
                                  params: { id: category.id },
                                }"
                              >
                                {{ category.name }}
                              </router-link>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                    <router-link
                      v-else
                      :to="{ name: subMenuLink.componentName }"
                    >
                      {{ instituteName }}
                    </router-link>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-list-item
                v-else-if="!hideForKuttab(headerList.hideForAlkuttab)"
                class="drawer-list-item"
              >
                <router-link
                  v-if="headerList.componentName"
                  :to="{ name: headerList.componentName }"
                  :class="{ disabled: headerList.isDisabled }"
                  exact
                >
                  {{ $t("header." + headerList.name) }}
                </router-link>
                <a :href="headerList.link" v-else-if="headerList.link">
                  {{ $t("header." + headerList.name) }}
                </a>
              </v-list-item>
              <!-- <hr /> -->
            </div>
            <v-list-item class="d-flex justify-content-between">
              <SwitchLang :drawer="true" />
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <LoginModal></LoginModal>
    </nav>
  </div>
</template>
<script>
import SwitchLang from "@/components/SwitchLang.vue"
import Logout from "@/components/Logout.vue"
import GlobalMixin from "@/GlobalMixin.js"
import { header } from "@/data/header.js"
import LoginModal from "@/components/global/LoginModal.vue"
import CurrencyList from "../CurrencyList.vue"
import SupportPalestine from "../SupportPalestine.vue"
import { mapActions, mapGetters } from "vuex"
import ProfileMenu from "../global/ProfileMenu.vue"
import MobileNavigationDrawer from "./MobileNavigationDrawer.vue"
import NotificationsPanel from "@/components/Notifications/NotificationsPanel.vue"

export default {
  name: "Header",
  mixins: [GlobalMixin],
  components: {
    SwitchLang,
    Logout,
    CurrencyList,
    LoginModal,
    SupportPalestine,
    ProfileMenu,
    MobileNavigationDrawer,
    NotificationsPanel,
  },
  data() {
    return {
      state: this.$store.getters,
      drawer: false,
      configs: this.getSafeConfigs(),
      institute: this.getSafeInstitute(),
      isScrolled: false,
      currentMenuId: null,
    }
  },
  /**
   * Initialize Component
   */
  mounted() {
    // this.getconfigurations();
    window.addEventListener("localstorageChange", event => {
      try {
        this.institute = event.detail.storage.institute_configs ? 
          JSON.parse(event.detail.storage.institute_configs) : this.getSafeInstitute()
        this.configs = event.detail.storage.configs ? 
          JSON.parse(event.detail.storage.configs) : this.getSafeConfigs()
      } catch (error) {
        console.error('Error updating configs from localStorage event:', error)
        this.institute = this.getSafeInstitute()
        this.configs = this.getSafeConfigs()
      }
    })
    window.addEventListener("scroll", this.handleScroll)
    this.getCourses()
  },
  methods: {
    ...mapActions(["toggleDashboardDrawer"]),
    ...mapActions("courses", ["setCourses"]),
    
    getSafeConfigs() {
      try {
        const configs = localStorage.getItem("configs")
        return configs ? JSON.parse(configs) : {}
      } catch (error) {
        console.error('Error parsing configs from localStorage:', error)
        return {}
      }
    },
    
    getSafeInstitute() {
      try {
        const institute = localStorage.getItem("institute_configs")
        if (institute) {
          return JSON.parse(institute)
        }
        // Dynamic fallback based on domain
        const isMainDomain = window.location.href.includes("alkuttab.io")
        return { 
          id: isMainDomain ? 1 : null, 
          name: isMainDomain ? 'Alkuttab' : 'Dclass' 
        }
      } catch (error) {
        console.error('Error parsing institute from localStorage:', error)
        // Dynamic fallback based on domain
        const isMainDomain = window.location.href.includes("alkuttab.io")
        return { 
          id: isMainDomain ? 1 : null, 
          name: isMainDomain ? 'Alkuttab' : 'Dclass' 
        }
      }
    },
    
    getSafeTranslation(key) {
      return this.$safeT(key)
    },

    handleScroll() {
      // Change isScrolled when user scrolls down beyond a threshold (e.g., 80px)
      this.isScrolled = window.scrollY > 80
    },
    openLoginModal() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: true,
            tab: 0,
          },
        })
      )
    },
    openRegisterModal() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: true,
            tab: 1,
          },
        })
      )
    },
    hideForKuttab(isHideForKuttab) {
      if (isHideForKuttab) {
        if (this.institute.id === 1) {
          return false // Show for Alkuttab (id = 1)
        }
        return true // Hide for other institutes
      }
      return false
    },
    // getCourseTypes() {},
    getCourses() {
      const { is_new_group_class_flow_enabled } = this.institute

      const body = {
        institute: this.institute.id,
        is_group: true,
      }

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}tutor/courses/${is_new_group_class_flow_enabled ? "?is_group=1" : ""}`,
          body,
          this.headers
        )
        .then(res => {
          const courses = res.data?.data?.courses || []
          this.setCourses(courses)
        })
    },
  },
  computed: {
    ...mapGetters("filters", ["filters"]),
    ...mapGetters("courses", {
      courses: "getCourses",
      status: "getStatus",
      error: "getError",
    }),

    profilePictureUrl() {
      if (this.state.isAuthenticated)
        return this.$store.getters.StateUser.user.profile_picture_url
      else return null
    },
    genderIcon() {
      if (!this.state.isAuthenticated) return null
      const user = this.$store.getters.StateUser.user
      if (user && user.gender && user.gender.toLowerCase() === "male") {
        return "mdi-account-tie"
      } else if (
        user &&
        user.gender &&
        user.gender.toLowerCase() === "female"
      ) {
        return "mdi-account-heart"
      } else {
        return "mdi-account"
      }
    },
    courseTypes() {
      return this.filters.find(
        filter => filter.api_param_name === "course_types"
      )
    },
    headerData() {
      try {
        return header(this.courseTypes, this.instituteName, this.courses)
      } catch (error) {
        console.error('Error generating header data:', error)
        return {
          headerLinks: [],
          header_menu: {
            student: [],
            tutor: [],
            operator: [],
            institute_admin: [],
            kids: []
          }
        }
      }
    },
    institute_name() {
      // Priority: institute.name > configs.institute_name > dynamic fallback
      let name = ''
      if (this.institute?.name) {
        name = this.institute.name
      } else if (this.configs?.institute_name?.config_value) {
        name = this.configs.institute_name.config_value
      } else {
        // Dynamic fallback based on domain
        const isMainDomain = window.location.href.includes("alkuttab.io")
        name = isMainDomain ? 'Alkuttab' : 'Dclass'
      }
      // Clean the name (remove "web" suffix)
      return this.cleanInstituteName(name)
    },
    isDashboardRoute() {
      return this.$route.path.includes("dashboard")
    },
    // navbar scroll update
    navbarClass() {
      return this.isScrolled ? "bg-white shadow-lg" : "bg-home"
    },
    navItemClass() {
      return this.isScrolled ? "nav-item-class" : "text-white"
    },
    subMenuNavItemClass() {
      return this.isScrolled ? "submenu-nav-item-scroll" : "submenu-nav-item"
    },
    scrollActions() {
      return this.isScrolled ? "scroll-actions" : ""
    },
    drawing() {
      return this.isScrolled ? "scrolled-drawer" : "drawer"
    },
    /**
     * Check whether user is student or not
     */
    isStudent() {
      return this.$store.getters.StateUser.user.user_type === "student"
    },
    /**
     * Gets full name of the logged user
     */
    fullName() {
      return `${this.$store.getters.StateUser.user.first_name} ${this.$store.getters.StateUser.user.last_name}`
    },
    /**
     * Gets institute logo for institute
     */
    instituteLogo() {
      return this.configs?.logo?.config_value || '/img/logo.png'
    },
    /**
     * Gets institute name for institute
     */
    instituteName() {
      // Priority: institute.name > configs.institute_name > dynamic fallback
      let name = ''
      if (this.institute?.name) {
        name = this.institute.name
      } else if (this.configs?.institute_name?.config_value) {
        name = this.configs.institute_name.config_value
      } else {
        // Dynamic fallback based on domain
        const isMainDomain = window.location.href.includes("alkuttab.io")
        name = isMainDomain ? 'Alkuttab' : 'Dclass'
      }
      // Clean the name (remove "web" suffix)
      return this.cleanInstituteName(name)
    },
  },
  watch: {
    /**
     * Watch for language change
     */
    "$i18n.locale"() {
      this.headers.headers["accept-language"] = localStorage.lang
      this.getconfigurations()
    },
  },
}
</script>
<style lang="scss" scoped>
.user-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashboard-drawer-icon {
  display: none;
}
@media (max-width: $min-md-screen) {
  .dashboard-drawer-icon {
    display: block;
  }
}
::v-deep .v-expansion-panel-content__wrap {
  border: none;
  padding: 0px 10px;
}
.bg-home {
  // background-color: #42437d !important;
  background-color: #2b2c59 !important;
}
.drawer-list-item {
  font-weight: 600;
  color: rgb(119, 119, 119);
}
.drawer-list-item > a {
  width: 100%;
  color: rgb(119, 119, 119);
}
.nav-container {
  display: grid;
  place-items: center;
  margin-top: -5px;
}
nav {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 70px;
  padding: 20px;
  font-family: $font-family;
  line-height: 24px;
  .logo {
    width: 200px;
    height: 46.28px;
    img {
      width: 80%;
      height: 75%;
      object-fit: contain;
    }
  }

  .drawer {
    display: none;
    cursor: pointer;
    .v-btn__content {
      i {
        color: $white;
      }
    }
    &:hover {
      background: rgba($black, 0.1);
      scale: 1.05;
      transition: all 0.3s ease;
    }
  }
  .scrolled-drawer {
    display: none;
    .v-btn__content {
      i {
        color: rgb(102, 102, 102);
      }
    }
  }

  .nav-item-class > a,
  .nav-item-class > span,
  .submenu-nav-item,
  .submenu-nav-item-text {
    color: rgb(56, 56, 56);
  }
  .submenu-nav-item,
  .submenu-nav-item-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .submenu-nav-item-text {
    padding: 0px;
  }

  .scroll-actions {
    button,
    a {
      color: rgb(56, 56, 56) !important;
    }
  }

  ul {
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 600;
    font-size: 0.9em;
    color: "#fff";

    li {
      position: relative;
      border-radius: 8px;
      height: 36px;
      &:hover .sub-menu-list {
        display: flex;
      }

      a,
      span {
        padding: 7px 17px;
        display: inline-block;
        cursor: pointer;
        color: $white;
        text-decoration: none;
        border-radius: 8px;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        i {
          margin-inline-start: 7px;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        &:hover::before {
          left: 100%;
        }

        &.router-link-exact-active.active {
          background: rgba(255, 255, 255, 0.15);
          color: $darker-green;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: $darker-green;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }

    &.sub-menu-list {
      display: none;
      width: 170px;
      background: white;
      box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.6);
      flex-direction: column;
      position: absolute;
      text-align: center;
      li {
        border-radius: 0px;
        &:hover {
          background: #d5d6d6;
          width: 100%;
          text-align: center;
        }
        a {
          display: block;
          color: $title-2 !important;
        }
        .sub-link-with-category {
          white-space: nowrap;
          width: 100%;

          span,
          i {
            color: $title-2;
          }
        }
      }
    }
  }

  .actions {
    font-weight: 500;
    font-size: 1em;
    gap: 8px;
    display: flex;

    a,
    button {
      padding: 8px;
      border-radius: 8px;
      color: $white;
      text-decoration: none;

      &.lang-btn {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      &.lang-btn,
      &.login-btn,
      &.logout-btn {
        margin: 0;

        &:hover {
          color: $darker-green;
        }
      }

      &.register-btn {
        border: transparent;
        color: $white !important;
        background: $hover-green;
        height: auto;
        font-weight: 600;
        font-size: 13px;
        border-radius: 9999px;
        box-shadow: none;
        text-transform: none;
        &:hover {
          background: $hover-green;
        }
      }

      &.profile-btn {
        color: $darker-green;
        border: 1px solid $darker-green;
        display: flex;
        align-items: center;
        gap: 8px;

        &:hover {
          background: #eee;
        }
      }
    }

    button.login-btn.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
      height: auto;
      background: none;
      box-shadow: none;
    }
  }

  .header--nav-dropdown-link {
    &:hover {
      color: #7caa2d;
    }
  }

  .dropdown-menu {
    a {
      border: none;
      color: #1976d2;

      &:hover {
        color: #7caa2d;
      }
    }
  }

  .dropdown {
    ul {
      all: unset;
    }
  }
}

.categories-list {
  display: flex;
  flex-direction: column;
  background: white;
  position: absolute;
  top: 0px;
  left: 170px;
  border-left: 4px solid $darker-green;
  z-index: 1000;
  box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.6);
  min-width: 120px;
  li {
    border-bottom: 1px solid #d5d6d6;
    &:last-child {
      border-bottom: none;
    }
  }
}

@media (max-width: $max-sm-screen) {
  nav {
    .logo {
      width: 200px;
      height: 46.28px;
      img {
        width: 50%;
        height: 48%;
        object-fit: contain;
      }
    }
  }
}
@media all and (min-width: 768px) and (max-width: 1200px) {
  nav {
    padding: 28px;
    line-height: 24px;
    font-size: 12px;

    /* .logo {
      width: 108px;
      height: 26.21px;
    } */

    .drawer,
    .scrolled-drawer {
      display: initial;
    }

    a {
      margin-inline-end: auto;

      img {
        width: 108px;
        height: 26px;
      }
    }

    ul {
      display: none;
      font-weight: 400;
      font-size: 1em;

      li {
        a,
        span {
          padding: 12px 16px;
        }
      }
    }

    .actions {
      button {
        display: none;
      }

      a:not(.logout-btn) {
        display: none;
      }
    }
  }
}

@media (max-width: 1200px) {
  .user-menu {
    display: none;
  }
}
@media all and (max-width: 768px) {
  nav {
    padding: 20px 16px;

    .drawer,
    .scrolled-drawer {
      display: block;
    }

    a {
      margin-inline-end: auto;

      img {
        width: 105px;
        height: 24px;
      }
    }

    ul {
      display: none;
    }

    .actions {
      button {
        display: none;
        &.user-menu {
          display: none;
        }
      }

      a:not(.logout-btn) {
        display: none;
      }
    }
  }
}
</style>
